<template>
  <ContainerScrolling class="EventsDashboard">
    <LayoutFill :no-gutters="solidHeader" :no-padding="solidHeader">
      <MainBanner title="Events" :solid-header="solidHeader" />
    </LayoutFill>

    <LayoutGutters class="mt-4">
      <SelectedEvents :events="eventSummaries" :show-large-title="false" />
    </LayoutGutters>

    <LayoutGutters class="mt-4">
      <SelectedArticles
        title="Latest Content"
        :articles="latestContent"
        :show-content-type="showContentTypeEvents"
        :show-large-title="false"
      />
    </LayoutGutters>
  </ContainerScrolling>
</template>

<script>
import { mapState } from "vuex";
import buildActionDispatcher from "~/actions/utilities/buildActionDispatcher";
import mapFlags from "~/plugins/utilities/mapFlags";
import LayoutGutters from "~/components/layout/LayoutGutters.vue";

import {
  displayIsMobile,
  displayIsTablet,
  displayIsDesktop,
} from "~/components/utilities/displayBreakpoints";

import ContainerScrolling from "~/components/layout/ContainerScrolling.vue";
import MainBanner from "~/components/banner/MainBanner.vue";
import SelectedArticles from "~/components/articles/SelectedArticles.vue";
import SelectedEvents from "~/components/events/SelectedEvents.vue";
import LayoutFill from "~/components/layout/LayoutFill.vue";

import getPageTitle from "~/plugins/utilities/getPageTitle.js";
import getSiteName from "~/plugins/utilities/getSiteName.js";
import toCanonicalUrl from "~/plugins/utilities/toCanonicalUrl.js";

export default {
  name: "EventsDashboard",
  components: {
    ContainerScrolling,
    MainBanner,
    LayoutFill,
    LayoutGutters,
    SelectedArticles,
    SelectedEvents,
  },
  async fetch(context) {
    const { $config, redirect, $unleash } = context;
    const partner = $config.partner;

    if (!$unleash.isEnabled("eventsDashboard")) {
      return redirect(`/engage/${partner}/public-dashboard`);
    }
    await buildActionDispatcher("loadEventsDashboard")(context);
  },
  head() {
    const { siteName, partner } = this;
    const title = getPageTitle(siteName);
    const pageTitle = "Browse Events" + " | " + title;
    const canonicalUrl = toCanonicalUrl(`events-dashboard`, partner);
    const cupTechText =
      this.partner === "chemrxiv"
        ? "technology provided by"
        : "brought to you by";

    return {
      title: pageTitle,
      meta: [
        {
          hid: "description",
          name: "description",
          content: `Browse events to discover early research outputs such as conference papers and presentations on ${siteName}, ${cupTechText} Cambridge University Press`,
        },
      ],
      link: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
  computed: {
    ...mapState({
      theme: (state) => state.theme,
      layout: (state) => state.theme.layout,
      eventSummaries: (state) => state.currentOrigin.eventSummaries,
      latestContent: (state) => state.currentOrigin.latestEventArticles,
      siteName: (state) => getSiteName(state.theme),
      domain: (state) => state.theme.domain,
    }),
    ...mapFlags(["showContentTypeEvents"]),
    displayIsDesktop,
    displayIsMobile,
    displayIsTablet,
    partner() {
      return this.$config.partner;
    },
    solidHeader() {
      return this.layout.mainBannerSolidHeader;
    },
  },
};
</script>
